import type { Node as ProsemirrorNode } from "prosemirror-model";

import React from "react";

import { ProductToken } from "@v2/features/chat/components/chat-elements/chat-tokens/ProductToken";
import { createRoot } from "react-dom/client";

/**
 * Custom NodeView for product tokens.
 * NOTE (Kevin, 2025-12-18): Uses createRoot instead of ReactNodeViewRenderer
 * to fix an issue where tokens weren't rendered correctly by Tiptap's
 * contentComponent mechanism.
 */
export function ProductTokenNode({ node }: { node: ProsemirrorNode }) {
  const dom = document.createElement("span");
  dom.className = "product-component";
  dom.contentEditable = "false";
  dom.style.display = "inline";

  const data = node.attrs.data;
  if (data && data.title) {
    const root = createRoot(dom);
    root.render(React.createElement(ProductToken, { data }));

    return {
      dom,
      destroy: () => {
        root.unmount();
      },
    };
  }

  return { dom };
}
